import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';
import moment from 'moment';
import { date } from 'yup';


RHFDateField.propTypes = {
    name: PropTypes.string,
    helperText: PropTypes.node,
    value: PropTypes.string
};

function renderDate(params) {
    if(params){
        return moment(params).format('MM/DD/YYYY');
    }
    return moment(new Date()).format('MM/DD/YYYY');;
};

export default function RHFDateField({ name, helperText, value,disabled, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <>
                    <TextField
                        onWheel={(e) => {
                            document.activeElement.blur();
                            return false;
                        }}
                        {...field}
                        fullWidth
                        value={renderDate(value)}
                        error={!!error}
                        helperText={error ? error?.message : helperText}
                        {...other}                        
                        inputProps={{
                            disabled                            
                        }}
                    />
                </>
            )}
        />
    );
}